import { some } from 'lodash';

import { Option } from '@components/Formik/MultiSelectFilter/types';
import { MemberFilter } from '@domui-presenters/web/components/DistrictMembersFilters/types';

import { ClubRosterFilter } from '@domui-domain/clubs';

export type FilterProps = MemberFilter | ClubRosterFilter;

export default (filters: FilterProps) =>
  some(filters, filter => (filter as Option[])?.length > 0);
